import ImagesLoaded from "imagesloaded";
import Isotope from "isotope-layout";
import React, { Component } from "react";
import { Link } from "react-router-dom";

import GalleryItemsData from "../../data/gallery/galleryItems";

class Gallery extends Component {
  componentDidMount() {
    var gallery_items_name = this.grid;
    var gallery_item_name = ".gallery-item";

    var iso = new Isotope(gallery_items_name, {
      itemSelector: gallery_item_name,
      masonry: {
        horizontalOrder: true,
      },
    });

    var imgLoad = new ImagesLoaded(gallery_items_name);

    imgLoad.on("progress", function (instance, image) {
      iso.layout();
    });
  }

  render() {
    return (
      <div className="gallery">
        <div className="gallery-item-wrapper">
          <div className="gallery-items" ref={(c) => (this.grid = c)}>
            {GalleryItemsData?.map((item, key) => {
              return (
                <div key={key} className={"gallery-item active " + item.category}>
                  <Link title={item.title} className="gallery-item-content" to={"/portfolio/" + item.link}>
                    <div className="img object-fit">
                      <div className="object-fit-cover">
                        <img src={item.imgSrc} alt={item.title} />
                      </div>
                    </div>

                    <div className="gallery-hover">
                      <h5 className="gallery-item-title">{item.title}</h5>

                      <p className="gallery-item-description">{item.shortDescription}</p>

                      <div className="gallery-item-btn no-space">
                        <span className="btn btn-link btn-line p-0 border-0 min-w-auto text-uppercase">More</span>
                      </div>
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>

        {!this.props.showFull && (
          <div className="spacer m-top-lg text-center">
            <Link title="See more" className="btn btn-outline-primary text-uppercase" to={"/portfolio"}>
              See more
            </Link>
          </div>
        )}
      </div>
    );
  }
}

export default Gallery;
